module.exports = __webpack_public_path__ + "images/gemeentezoetermeer_small4424fea37a20a5d7469e032701f8ab7a.png";